import { ADMIN_USERS } from '../../constants/APIKEYS'

const KEY = ADMIN_USERS

let swrData: any = null

export function useUserList() {
	// const { data: token } = useToken()
	// const { data, mutate } = useSWR<any>(
	// 	KEY,
	// 	async () => {
	// 		const response = await API.get(
	// 			KEY + '?maxData=100&page=1&level=1&order=ASC&ordertype=id',
	// 			token + '',
	// 			{}
	// 		)

	// 		swrData = response?.result?.result?.list || []
	// 		return swrData
	// 	},
	// 	{ revalidateOnFocus: false, dedupingInterval: 300000 }
	// )

	// const usertype1 =
	// 	(data?.length > 0 &&
	// 		data?.map((item: any) => {
	// 			return {
	// 				value: item?.id,
	// 				label: item?.id + '_' + (item?.fullname || item?.nickname),
	// 			}
	// 		})) ||
	// 	[]

	return {
		userlist: [],
		usertype1: [],
		mutate: (value: any) => {
			swrData = value
			//return mutate()
		},
	}
}
